<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">商品管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>供应商</label>
              <el-select v-model="supplierId" placeholder="Select" class="select-item" filterable>
                <el-option v-for="item in supplierIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>品牌</label>
              <el-select v-model="brandId" placeholder="Select" class="select-item" filterable>
                <el-option v-for="item in brandIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <!--          <div class="content-input-item">-->
            <!--            <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
            <!--          </div>-->
            <div class="content-input-item">
              <label>商品名称</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
            </div>
            <div class="content-input-item">
              <label>启用状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <commodity-type-list @confirm="getCommodityType($event)" :reSet="reSet" />
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editCommodityDialog(-1)" size="default">添加</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="supplierName" label="供应商" v-if="checkColList.indexOf('供应商') > -1"/>
            <el-table-column property="brandName" label="品牌" v-if="checkColList.indexOf('品牌') > -1"/>
            <el-table-column property="name" label="商品名称" v-if="checkColList.indexOf('商品名称') > -1"/>
            <el-table-column property="" label="商品图片" v-if="checkColList.indexOf('商品图片') > -1">
              <template #default="scope">
                <div v-if="scope.row.commodityImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
                  <el-image class="item-img" fit="cover" :src="scope.row.commodityImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="commodityTypeName" label="商品分类" v-if="checkColList.indexOf('商品分类') > -1">
              <template #default="scope">
                {{scope.row.commodityTypePreName?scope.row.commodityTypePreName + '/':''}}{{scope.row.commodityTypeName}}
              </template>
            </el-table-column>
            <el-table-column property="specification" label="商品规格" v-if="checkColList.indexOf('商品规格') > -1"/>
            <el-table-column property="measureUnitName" label="计量单位" v-if="checkColList.indexOf('计量单位') > -1"/>
            <el-table-column property="price" label="进货单价" v-if="checkColList.indexOf('进货单价') > -1"/>
            <el-table-column property="retailPrice" label="建议零售价" v-if="checkColList.indexOf('建议零售价') > -1"/>
            <el-table-column property="shopRetailPrice" label="门店零售价" v-if="checkColList.indexOf('门店零售价') > -1"/>
            <el-table-column property="visitDay" label="回访天数" v-if="checkColList.indexOf('回访天数') > -1">
              <template #default="scope">
                {{scope.row.visitDay == -1?'无需回访':scope.row.visitDay == 0?'立即回访':scope.row.visitDay}}
              </template>
            </el-table-column>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':'' }}</p>
              </template>
            </el-table-column>
<!--            <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"/>-->
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button @click="editCommodityDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 1" @click="updateState(scope.row, 2)" size="small" type="warning" v-loading="scope.row.updateLoading">停用</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">开启</el-button>
                  <el-button @click="editCommodityDialog(-2,scope.row)" size="small" type="danger">复用</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {listAllSupplier,listAllBrand, getCommodityPageList, updateCommodityState} from "@/api/url";
import CommodityDialog from "./components/CommodityDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import unLock from "@/layout/components/unLock";
import commodityTypeList from "@/components/commodityTypeList";

export default {
  name: "CommodityIndex",
  components: { BtnGroup, SearchComponents, unLock, commodityTypeList },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      supplierIdArray: [],
      supplierId: 0,

      brandIdArray: [],
      brandId: 0,

      limitState: false,

      shopIdArray: [
        {name: '不限', id: -1},
      ],
      shopIdArr:[],
      shopId: -1,

      stateArray: [
        {label: '不限', value: -1},
        // {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['创建时间', '供应商', '品牌', '商品名称', '商品图片', '商品分类','商品规格', '计量单位', '进货单价', '建议零售价', '门店零售价', '回访天数', '状态', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '门店名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      commodityTypeId: 0,
      commoditySubTypeId: 0,
      reSet: false

    }
  },
  methods: {

    getCommodityType(e) {
      console.log(e)
      this.commodityTypeId = e[0]
      this.commoditySubTypeId = e[1]
      this.reSet = e[2]
    },

    // 重置参数
    refreshParam() {
      // this.isChecked = true;
      this.reSet = true
      this.state = -1;
      this.limitState = false;
      this.brandId = 0;
      this.supplierId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['supplierId'] = this.supplierId;
      param['brandId'] = this.brandId;
      param['limitState'] = this.limitState?1:0;
      param['searchValue'] = this.searchValue;
      param['commodityTypeId'] = this.commoditySubTypeId>0?this.commoditySubTypeId:this.commodityTypeId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getCommodityPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editCommodityDialog(idx, row) {
      let _title = '';
      let commodityForm = {}
      if (idx > -1) {
        _title = '编辑商品'
        commodityForm = Object.assign({}, row);
        // console.log(commodityForm)
      }else {
        _title = '添加商品'
        if(idx == -2) {
          commodityForm = Object.assign({}, row);
        }
        // console.log(commodityForm)
      }
      Dialog.open({
        title: _title,
        component: CommodityDialog,
        data: {
          commodityForm: commodityForm,
          ids: idx,
          width: '670px',
        },
        confirm: (result) => {
          this.getPage()
        },
        goNext: (result) => {
          if(result == 1) {
            this.$router.push({
              path: '/commodity/supplier'
            })
          }
          if(result == 2) {
            this.$router.push({
              path: '/commodity/brand'
            })
          }
        }
      })
    },


    getSupplierList() {
      getFormData(listAllSupplier).then(data=> {
        this.supplierIdArray = [
          {name: '不限', id: 0}
        ]
        this.supplierIdArray = this.supplierIdArray.concat(data.data)
      })
    },

    getBrandList() {
      getFormData(listAllBrand).then(data=> {
        this.brandIdArray = [
          {name: '不限', id: 0}
        ]
        this.brandIdArray = this.brandIdArray.concat(data.data)
      })
    },


    updateState(row, state) {
      this.$confirm('确认' + (state == 1?'开启':'停用') + '商品【' + row.name + '】？').then(() => {
        row.updateLoading = true;
        let param = {};
        param['id'] = row.id;
        param['state'] = state;
        postFormData(updateCommodityState, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.state = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateLoading = false;
        }).catch(()=> {
          row.updateLoading = false;
        })
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.id,
          width: 908,
          from: 2
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getSupplierList()
    this.getBrandList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
